import React, { Component } from "react";
import {Card, Form, Button, Row, Col} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import AsyncSelect from 'react-select/async';
import { FaEdit, FaCheck, FaTimes, FaStream } from "react-icons/fa";
import CreatableSelect from 'react-select/creatable';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import '../ProgramasV2/ProgramasEdit.module.css';

class MonitoriaPrograma extends Component {
    constructor(props) {
        super(props);
        this.state = {
            aplicacoes_legenda: "" ,
            status_aplicacao: [{nome: "", motivos_nao_realizacao: ""}],
            programa_id: this.props.programa_id,
            dadosMonitoriaPrograma: this.props.dadosMonitoriaPrograma,
            monitoria_tipos: [],
            erroLoadRegistro: '',
            loading: false,
            page_numb: this.props.page_numb || 1,
            page_limit: this.props.page_limit || 10
        }
    }

    componentDidMount() {
        //this.carregarDadosMonitoriaPrograma();
        this.carregarStatusAplicacao();
        this.carregaMonitoriaTipos();
    }

    carregaMonitoriaTipos = async () => {
        try {
            const response = await api.get(`/programas/aplicacoes-tipos/?programa_id=${this.state.programa_id}`);
            const opcoes = response.data.results.map(tipos => ({
                value: tipos.id,
                label: tipos.nome
            }));
            this.setState({ monitoria_tipos: opcoes });
        } catch (error) {
            console.error('Erro ao carregar tipos:', error);
            return [];
        }
    };

    
    removeMonitoriaTipos = async(id) => {
        const url = `/programas/aplicacoes-tipos/${id}`;
        const metodo = 'DELETE';

        api({
            method: metodo,
            url: url
        })
        .then(response => {
            this.setState(({
                monitoria_tipos: this.state.monitoria_tipos.filter(tipo => tipo.value !== id),
            }));
            
        })
        .catch(error => {
            console.error("Erro ao remover um novo Tipo: " + error)
        });    
    }

    handleChangeMonitoriaTipos = async (selectedOptions) => {
        // Detecta os tipos removidos comparando com o estado anterior
        const removedItems = this.state.monitoria_tipos.filter(
            (item) => !selectedOptions.some((option) => option.value === item.value)
        );
        if (removedItems.length > 0) {
            // Aqui você sabe que um item foi removido
            console.error('Tipo removido:', removedItems);
            // Chama a função para deletar o tipo na API
            removedItems.forEach((item) => this.removeMonitoriaTipos(item.value));
        }

        this.setState(({
            monitoria_tipos: selectedOptions,
        }));
        
    }

    criaMonitoriaTipos = async (valor) => {
        const url = `/programas/aplicacoes-tipos/`;
        const metodo = 'post';
    
        const dadosInsert = {
            nome: valor,
            programa_id: this.state.programa_id
        }

        await api({
            method: metodo,
            url: url,
            data: dadosInsert,
        })
        .then(response => {
            this.setState(prevState => ({
                monitoria_tipos: [...prevState.monitoria_tipos, { value: response.data.id, label: response.data.nome }],
            }));
            
        })
        .catch(error => {
            console.error("Erro ao cadastrar um novo Tipo: " + error)
        });

    }

    enviaMonitoria = async () => {
        const formData = new FormData();
    
        const url = '/programas/' + this.state.programa_id + '/';
        const metodo = 'put';
    
        if (this.state.aplicacoes_legenda) {
            formData.append('aplicacoes_legenda', this.state.aplicacoes_legenda);
        }

        try {
            // Enviar os dados para o backend
            const response = await api({
                method: metodo,
                url: url,
                data: formData,
            });

            // Exibir a mensagem de sucesso
            const MySwal = withReactContent(Swal);
            const textSwal = 'Monitoria atualizado com sucesso';
    
            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            });
    
            this.setState({
                loading: false,
            });
        } 
        catch (error) {
            let erro_msg = "Erro ao realizar o cadastro:<br />";
    
            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const responseData = error.response.data;
                const campos = responseData.erros ? responseData.erros : responseData;
                // Adicionar lógica para exibir mensagens de erro específicas, se necessário
            }
    
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção!",
                html: erro_msg,
            });
    
            this.setState({
                loading: false,
            });
        }    
    } 

    salvarStatusAplicacao = (index) => {
        const status = this.state.status_aplicacao[index];
        const url = status.id ? `/programas/aplicacoes-status/${status.id}/` : '/programas/aplicacoes-status/';
        const metodo = status.id ? 'put' : 'post';
    
        const dadosStatus = {
            nome: status.nome,
            motivos_nao_realizacao: status.motivos_nao_realizacao,
            programa_id: this.state.programa_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosStatus,
        })
        .then(response => {
            // Se for um novo botao, atualize o estado com a ID retornada pela API
            if (!status.id) {
                this.setState(prevState => {
                    const statusAtualizados = [...prevState.status_aplicacao];
                    statusAtualizados[index].id = response.data.id;
                    return { status_aplicacao: statusAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (status.id) ? 'Status da aplicação atualizado com sucesso' : 'Status da aplicação cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o status da aplicação, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'nome') {
                        content += `<br>&bull; Nome: ${value}`;
                    }
                    if(key == 'programa_id') {
                        content += `<br>&bull; Id do programa: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
        
    }

    carregarStatusAplicacao = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/aplicacoes-status/?programa_id=${this.state.programa_id}`)
            .then(response => {
                const statusCarregado = response.data.results.map(status => ({
                    id: status.id,
                    nome: status.nome,
                    motivos_nao_realizacao: status.motivos_nao_realizacao
                }));
                this.setState({ status_aplicacao: statusCarregado });
            })
            .catch(error => {
                console.error('Erro ao carregar status:', error);
                
                let erro_msg = 'Erro ao carregar status da aplicação, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
    }

    
    removerStatusAplicacao = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover status da aplicação?',
            text: "Tem certeza que deseja remover este status da aplicação?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const status = this.state.status_aplicacao[index];

                if (status.id) {
                    api({
                        method: 'delete',
                        url: `/programas/aplicacoes-status/${status.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Status da aplicação removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            status_aplicacao: prevState.status_aplicacao.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o status da aplicação, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        status_aplicacao: prevState.status_aplicacao.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O status da aplicação foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    handleChangeLegendaAplicacoes = (value) => {
        this.setState({ aplicacoes_legenda: value });
    };

    handleChangeStatusAplicacao = (index, event, fieldName) => {
        const status_aplicacao = [...this.state.status_aplicacao];
        status_aplicacao[index] = { ...status_aplicacao[index], [fieldName]: event.target.value };
        this.setState({ status_aplicacao });
    };

    adicionarStatusAplicacao = () => {
        this.setState(prevState => ({
            status_aplicacao: [...prevState.status_aplicacao, {nome: "", motivos_nao_realizacao: ''}],
        }));
    };

    render() {
        return (
            <>
                <Card className="cardDestaque">
                    <Card.Body>
                        <Row style={{marginBottom: "10px"}}>
                            <h4>Monitoria de aplicações</h4>
                            <Col sm={4} xs={12}>
                                <Form.Group>
                                    <Form.Label>Tipos</Form.Label>
                                    <CreatableSelect
                                        isMulti
                                        onChange={(e) => this.handleChangeMonitoriaTipos(e)}
                                        options={this.state.monitoria_tipos}
                                        value={this.state.monitoria_tipos}
                                        placeholder="Selecione ou crie tipos"
                                        onCreateOption={(e) => this.criaMonitoriaTipos(e)}
                                        getOptionLabel={(e) => (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <span>{e.label}</span>
                                            
                                        </div>
                                        )}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={8} xs={12}>
                                <Form.Group>
                                    <Form.Label>Legenda de Aplicações</Form.Label>
                                    <ReactQuill
                                        value={this.state.dadosMonitoriaPrograma.aplicacoes_legenda}
                                        name="aplicacoes_legenda"
                                        onChange={(e) => this.handleChangeLegendaAplicacoes(e)}
                                        theme="snow" // Tema do editor, pode ser "snow" ou "bubble"
                                        modules={{
                                            toolbar: [
                                            [{ header: '1' }, { header: '2' }, { font: [] }],
                                            [{ list: 'ordered' }, { list: 'bullet' }],
                                            ['bold', 'italic', 'underline'],
                                            ['link', 'image'],
                                            [{ align: [] }],
                                            ['clean'],
                                            ],
                                        }}
                                        placeholder="Digite seu conteúdo aqui"
                                        className="form-control"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form>
                                    <h4>Status de Aplicação</h4>
                                    {this.state.status_aplicacao.map((status, index) => (
                                    <div key={index} className="row-list">
                                        <Row style={{marginBottom: "10px"}}>                                                
                                            <Col sm={4} xs={12}>
                                                <Form.Group>
                                                    <Form.Label>Nome</Form.Label>   
                                                    <Form.Control 
                                                        type="text"                                                             
                                                        name="nome"
                                                        value={status.nome} 
                                                        onChange={(e) => this.handleChangeStatusAplicacao(index, e, "nome")}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={8} xs={12}>
                                                <Form.Group>
                                                    <Form.Label>Motivos de não aplicação (Separe os motivos por vírgula)</Form.Label>   
                                                    <Form.Control 
                                                        type="text"                                                             
                                                        name="motivos_nao_realizacao"
                                                        value={status.motivos_nao_realizacao} 
                                                        onChange={(e) => this.handleChangeStatusAplicacao(index, e, "motivos_nao_realizacao")}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Button variant="success" className="btn-sm" onClick={() => this.salvarStatusAplicacao(index)}><FaCheck className="me-1" /> Salvar Status</Button>&nbsp;&nbsp;
                                        <Button variant="danger" className="btn-sm ms-2" onClick={() => this.removerStatusAplicacao(index)}><FaTimes className="me-1" /> Remover Status</Button>
                                    </div>
                                    ))}
                                    <Button variant="secondary" onClick={this.adicionarStatusAplicacao}><FaStream /> Adicionar Status</Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                        <Button variant="success" className="btn-submit mt-3" disabled={this.state.loading} onClick={(e) => this.enviaMonitoria()}>
                            {this.state.loading ? (
                                <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                                <>
                                    <FaCheck className="me-1" /> Salvar Dados da Monitoria
                                </>
                            )}
                        </Button>
                    </Card.Body>
                </Card>
            </>
        );
    }
}

export default MonitoriaPrograma;

